import { render, staticRenderFns } from "./CourseContentsTemplateMixin.vue?vue&type=template&id=afe46a9a&"
import script from "./CourseContentsTemplateMixin.vue?vue&type=script&lang=js&"
export * from "./CourseContentsTemplateMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports